import React from 'react';
import PropTypes from 'prop-types';
import gtm from 'general/js/gtm';
import { mediaTypes } from 'components/posts';
import NewsCard from '../../cards/js/news-card';
import FactCard from '../../cards/js/fact-card';
import PlayerCard from '../../cards/js/player-card';
import SocialCard from '../../cards/js/social-card';
import StandaloneFactCard from '../../cards/js/standalone-fact-card';
import { themeNames } from './enums';

class NewsFeedListing extends React.Component {
    constructor(props) {
        super(props);

        this.onCardLinkClick = this.onCardLinkClick.bind(this);
    }

    getCardByTheme(model, slotModifiers) {
        switch (model.theme) {
            case themeNames.NEWS:
                return (
                    <NewsCard model={model}
                        bemModifiers={[...slotModifiers]}
                        onCardLinkClick={this.onCardLinkClick} />
                );
            case themeNames.PLAYER:
                return (
                    <PlayerCard model={model}
                        bemModifiers={[...slotModifiers]}
                        onCardLinkClick={this.onCardLinkClick} />
                );
            case themeNames.FACT:
                return (
                    <FactCard model={model}
                        bemModifiers={[...slotModifiers]}
                        onCardLinkClick={this.onCardLinkClick} />
                );
            case themeNames.STANDALONE_FACT:
                return (
                    <StandaloneFactCard model={model} bemModifiers={[...slotModifiers]} />
                );
            case themeNames.TWITTER:
                return (
                    <SocialCard model={model} bemModifiers={[...slotModifiers, 'twitter']} />
                );
            case themeNames.INSTAGRAM:
                return (
                    <SocialCard model={model} bemModifiers={[...slotModifiers, 'instagram']} />
                );
            case themeNames.FACEBOOK:
                return (
                    <SocialCard model={model} bemModifiers={[...slotModifiers, 'facebook']} />
                );
            default:
                console.log(`Unknown card theme: ${model.theme}, rendering has been ignored.`);
                return null;
        }
    }

    onCardLinkClick(model) {
        const actionClick = 'Click';
        const fullTitle = this.getFullTitle(model);
        const currentLocation = window.location.href;
        const trackingCategory = this.getTrackingCategory(model.type);
        const label = `${fullTitle} > ${currentLocation}`;

        gtm.push(trackingCategory, actionClick, label);
    }

    getFullTitle(model) {
        const { title, subtitle } = model;
        return title + (subtitle ? ` / ${subtitle}` : '');
    }

    getTrackingCategory(contentType) {
        switch (contentType) {
            case mediaTypes.VIDEO_PLAYER:
                return 'Video Player';
            case mediaTypes.GALLERY:
                return 'Gallery';
            default:
                return 'Article';
        }
    }

    getRowPattern(itemIndex) {
        const pattern = this.props.pattern;

        if (!Array.isArray(pattern)) return null;

        const totalSlots = pattern.reduce((acc, cur) => acc + cur.slots.length, 0);
        const slotIndex = itemIndex % totalSlots;
        let total = 0;

        for (let i = 0; i < pattern.length; i++) {
            const row = pattern[i];

            total += row.slots.length;

            if (slotIndex <= total - 1) {
                return row;
            }
        }

        return null;
    }

    renderRow(pattern, cardsList, index) {
        const rowCss = pattern.modifiers.map((x) => `news-feed-row--${x}`).join(' ');
        const gridCss = pattern.modifiers.map((x) => `news-feed-grid--${x}`).join(' ');

        return (
            <div className={`news-feed-row ${rowCss}`} key={index}>
                <div className={`news-feed-grid ${gridCss}`}>
                    {
                        cardsList.map((card, i) => {
                            const slot = pattern.slots[i];
                            const slotCss = slot.modifiers.map((x) => `news-feed-slot--${x}`).join(' ');

                            return (
                                <div className={`news-feed-slot ${slotCss}`} key={card.id}>
                                    {this.getCardByTheme(card, slot.modifiers)}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    renderCards() {
        const cardsList = this.props.items || [];
        const grid = [];
        let i = 0;
        let index = 0;

        while (i < cardsList.length) {
            const rowPattern = this.getRowPattern(i);

            if (!rowPattern) return null;

            grid.push(this.renderRow(
                rowPattern,
                cardsList.slice(i, i + rowPattern.slots.length),
                index,
            ));

            i += rowPattern.slots.length;
            index++;
        }

        return grid;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderCards()}
            </React.Fragment>
        );
    }
}

NewsFeedListing.propTypes = {
    items: PropTypes.array.isRequired,
    pattern: PropTypes.array.isRequired
};

export default NewsFeedListing;
